// Download / import master barang (owner 2026-10-12): pure helpers of the import panel
// (no imports, so Jest can test them).

export const STATUS_LABEL = {
  DIBUAT: "Baru", DIUBAH: "Diubah", SAMA: "Sama", BENTROK: "Bentrok", BERMASALAH: "Bermasalah", DILEWATI: "Dilewati",
};
const URUTAN = ["DIBUAT", "DIUBAH", "BENTROK", "BERMASALAH", "DILEWATI", "SAMA"];

const FIELD_LABEL = {
  nama: "Nama", kategori_kode: "Kategori", satuan: "Satuan", harga_enduser: "Harga Enduser",
  harga_reseller: "Harga Reseller", harga_member: "Harga Member", hpp: "HPP", is_active: "Aktif",
  pelengkap_jersey: "Pelengkap Jersey", mode_harga: "Mode harga", jenis_mesin_kode: "Jenis mesin",
  sub_kategori: "Sub-kategori", harga_mulai_dari: "Harga mulai dari", waktu_produksi_hari: "Waktu produksi (hari)",
  syarat_bayar: "Syarat bayar", spesifikasi: "Spesifikasi", hpp_belum_diisi: "HPP belum diisi", strata: "Strata (jumlah)",
  perlu_dicek: "Perlu dicek",  // v2.17.4: never an internal field name in the preview
};
const RUPIAH = new Set(["harga_enduser", "harga_reseller", "harga_member", "hpp"]);

export function labelField(f) {
  return FIELD_LABEL[f] || f;
}

export function nilai(f, v) {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "boolean") return v ? "YA" : "TIDAK";
  if (RUPIAH.has(f) && typeof v === "number") return `Rp${v.toLocaleString("id-ID")}`;
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

// filter chips: statuses present in the summary (in a fixed order) plus the extra views
export function filterList(ringkasan) {
  const ada = URUTAN.filter((s) => (ringkasan?.[s] || 0) > 0);
  return [
    { key: "PENTING", label: "Perlu dilihat", n: null },
    ...ada.map((s) => ({ key: s, label: STATUS_LABEL[s], n: ringkasan[s] })),
    ...((ringkasan?.perlu_dicek || 0) > 0 ? [{ key: "PERLU_DICEK", label: "Perlu dicek", n: ringkasan.perlu_dicek }] : []),
    { key: "SEMUA", label: "Semua", n: null },
  ];
}

// PENTING = every row except the unchanged ones
export function saringBaris(baris, filter) {
  return (baris || []).filter((b) => {
    if (filter === "SEMUA") return true;
    if (filter === "PENTING") return b.status !== "SAMA" || (b.peringatan || []).length > 0;
    if (filter === "PERLU_DICEK") return ["DIBUAT", "DIUBAH"].includes(b.status) && (b.perlu_dicek || []).length > 0;
    return b.status === filter;
  });
}

export function jumlahTerapkan(ringkasan) {
  return (ringkasan?.DIBUAT || 0) + (ringkasan?.DIUBAH || 0);
}
